module.exports = __webpack_public_path__ + "static/leads@2x-0360bfcbf9ae78161990324bfa14daa8.png";